import SpecialistService from '../../service/specialist'
import moment from 'moment'

const Action = {
    GET_WORK_TIME: 'GET_WORK_TIME',
    GET_WORK_TIME_ERROR: 'GET_WORK_TIME_ERROR',

    REFRESH_WORK_TIME: 'REFRESH_WORK_TIME',

    UPDATE_WORK_TIME: 'UPDATE_WORK_TIME',
    UPDATE_WORK_TIME_ERROR: 'UPDATE_WORK_TIME_ERROR',

    GET_AVAILABLE_WORK_TIME: 'GET_AVAILABLE_WORK_TIME',
    GET_AVAILABLE_WORK_TIME_ERROR: 'GET_AVAILABLE_WORK_TIME_ERROR',
}

const ActionCreator = {
    /*
    | -------------------------------------------------------------------------
    | Given a range of date
    | Get the work time that the medical scheduled
    | -------------------------------------------------------------------------
    | Arguments:
    | from: <string> date string formatted 'YYYY-MM-DD' (optional)
    | to: <string> date string formatted 'YYYY-MM-DD' (optional)
    |
    | Returns:
    | workTime: <object[]>
    |    { date: <string> date string formatted 'YYYY-MM-DD'
    |      timePeriodId: <integer> Scheduling period id. (either 7 or 8 or 9)
    |      markedPriceCent: <integer> marked price in terms of cents
    |    }
    |    Ex: [ { date: '2021-01-15', timePeriodId: 8, markedPriceCent: 10000 }]
    | -------------------------------------------------------------------------
    */
    getWorkTime({ from, to }) {
        return async dispatch => {
            try {
                const workTime = await SpecialistService.getWorkTime({ from, to })
                dispatch({ type: Action.GET_WORK_TIME, workTime, params: { from, to } })
                return workTime
            } catch (error) {
                return dispatch({ type: Action.GET_WORK_TIME_ERROR, error })
            }
        }
    },
    /*
    | -------------------------------------------------------------------------
    | Refresh worktime schedules by the current parameters
    | -------------------------------------------------------------------------
    | Arguments: None
    |
    | Returns:
    |  workTime: <object[]>
    |    { date: <string> date string formatted 'YYYY-MM-DD'
    |      timePeriodId: <integer> Scheduling period id. (either 7 or 8 or 9)
    |      markedPriceCent: <integer> marked price in terms of cents
    |    }
    |    Ex: [ { date: '2021-01-15', timePeriodId: 8, markedPriceCent: 10000 }]
    | -------------------------------------------------------------------------
    */
    refreshWorkTime() {
        return async (dispatch, getState) => {
            return await dispatch(ActionCreator.getWorkTime(getState().specialist.lastGetWorkTime))
        }
    },
    updateWorkTime({ date, timePeriodId, markedPriceCent, isOptingOut = false }) {
        return async dispatch => {
            try {
                await SpecialistService.updateWorkTime({ date, timePeriodId, markedPriceCent, isOptingOut })
                return await dispatch(ActionCreator.refreshWorkTime())
            } catch (error) {
                return dispatch({ type: Action.UPDATE_WORK_TIME_ERROR, error })
            }
        }
    },
    /*
    | -------------------------------------------------------------------------
    | Given division, medical, and/or a range of date
    | Get the available work time that vip can make appointment
    | -------------------------------------------------------------------------
    | Arguments:
    | division: <int> division id for filtering (optional)
    | medical: <int> medical id for filtering (optional)
    | from: <string> date string formatted 'YYYY-MM-DD' (optional)
    | to: <string> date string formatted 'YYYY-MM-DD' (optional)
    |
    | Returns:
    | timePeriods: <object[]>
    |    { id: <int> time period id
    |      label: <string> e.g. "morning", "noon", "night"
    |      name: <string> e.g. "早診", "午診", "晚診"
    |      range: <object>
    |      { from: <string> time string formatted 'HH:mm:ss'
    |        to: <string> time string formatted 'HH:mm:ss'
    |      }
    |      periods: <object[]>
    |      { from: <string> time string formatted 'HH:mm:ss'
    |        to: <string> time string formatted 'HH:mm:ss'
    |        workEvents: <object[]>
    |        { date: <string> date string formatted 'YYYY-MM-DD'
    |          timePeriodId: <integer> Scheduling period id. (either 7 or 8 or 9)
    |          markedPriceCent: <integer> marked price in terms of cents
    |          medicalId: <integer> the id of the medical
    |        }
    |      }
    |    }
    | medicals: <object[medicalId]>
    |    { medicalId: <int> id of the medical
    |      divisionId: <int> id of the medical's division
    |      name: <object>
    |      { firstName: <string> given name in user table
    |        lastName: <string> family name in user table
    |      }
    |      avatar: <string> the url of the avatar
    |      city: <object> the city object
    |      { id: <int> city id
    |        name: <string> city name in zh-TW
    |        region: <object> the region object
    |        { id: <int> region id
    |          name: <string> region name in zh-TW
    |          no: <string> one character: N, C, S, E, I
    |        }
    |      }
    |      institution: <object> the institution object
    |      { id: <int> institution id
    |        city: <object> the city object (please refer to the city object above)
    |        name: <string> name of the institution
    |        address: <string> address of the institution
    |        tel_no: <string> tel of the institution
    |        website: <string> website url of the institution
    |        level: <string> level of the institution e.g. "醫學中心", "區域醫院"
    |        lat: <number> lat of the institution
    |        lng: <number> lng of the institution
    |        type: <string> type of the institution e.g. "hospital", "醫院"
    |      }
    |      score: <number> score of the medical, should be 0.0 to 5.0
    |      numberConsultation: <int> consultation counter for calc avg of score
    |    }
    | -------------------------------------------------------------------------
    */
    getAvailableWorkTime({ division, medical, from, to, past }) {
        return async dispatch => {
            try {
                const availableWorkTime = await SpecialistService.getAvailableWorkTime({ division, medical, from, to, past })
                dispatch({ type: Action.GET_AVAILABLE_WORK_TIME, availableWorkTime })
                return availableWorkTime
            } catch (error) {
                return dispatch({ type: Action.GET_AVAILABLE_WORK_TIME_ERROR, error })
            }
        }
    },
    getAvailableWorkTimeByAdminMedical({ division, medical, institution, from, to, past }) {
        return async dispatch => {
            try {
                const availableWorkTime = await SpecialistService.getAvailableWorkTimeByAdminMedical({ division, medical, from, to, past })
                dispatch({ type: Action.GET_AVAILABLE_WORK_TIME, availableWorkTime })
                return availableWorkTime
            } catch (error) {
                return dispatch({ type: Action.GET_AVAILABLE_WORK_TIME_ERROR, error })
            }
        }
    },
}

const initState = {
    lastGetWorkTime: {
        from: moment().startOf('isoWeek').format('YYYY-MM-DD'),
        to: moment().endOf('isoWeek').format('YYYY-MM-DD'),
    },
    workTime: {},
    availableWorkTime: {},
}

function Reducer(state = initState, action) {
    switch (action.type) {
        case Action.GET_WORK_TIME:
            return {
                ...state,
                lastGetWorkTime: action.params,
                workTime: action.workTime,
            }
        case Action.GET_AVAILABLE_WORK_TIME:
            return {
                ...state,
                availableWorkTime: action.availableWorkTime,
            }
        case Action.UPDATE_WORK_TIME_ERROR:
            return {
                ...state,
                error: action.error,
            }
        default:
            return state
    }
}

export default { Action, ActionCreator, Reducer }



// WEBPACK FOOTER //
// ./src/store/actionreducers/specialist.js